import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'faire_direct-sign_up_flow_link_to_sign_in-click';

/**
 * Fires when user clicks link to "Sign in" from "Already have an account? Sign in" in the widget and directrequireemail versions of the sign up flow.

signUp parameter is the value of the signUp query param type (eg "directrequireemail", "widgetv2")
 */
export function trackFaireDirectSignUpFlowLinkToSignInClick(
  signUp: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { signUp },
  });
}
